import React from 'react';

import PropTypes from 'prop-types';
import _ from 'lodash';
import { Button, Typography } from '@telus-uds/components-web';
import Download from '@telus-uds/palette-allium/build/web/icons/Download';

import { useLocalizedStringsContext } from '../../../../../../context/LocalizedStringsContext';
import {
  isOrderFulfillmentTeam,
  isAdmin,
  isSalesRep
} from '../../../../../../utils/request';
import { isCustomPricingCorporate as checkCustomPricingCorporate } from '../../../../../../utils/corporatePricing';
import Attachements from './attachements';

const OrderAttachments = ({ orderData }) => {
  const localizedString = useLocalizedStringsContext();
  const { iotAccountType, iotCorporateType, pdfLinks } = orderData;
  const {
    ORDERS: {
      labelContractPDF,
      contractUnSigned,
      contractSignedPdf,
      attachments
    },
    contentfulValues: { valueCorporate, valueCorporateStandardPricing }
  } = localizedString;

  const isCustomPricingCorporate = checkCustomPricingCorporate(
    iotAccountType,
    iotCorporateType,
    { valueCorporate, valueCorporateStandardPricing }
  );

  if (isSalesRep && !_.get(orderData, `pdfLinks.contractSignedPdf`, false))
    return null;

  const getLink = (name, label) =>
    _.get(pdfLinks, name, '') && (
      <li
        className="list-group-item"
        style={{ display: 'flex', justifyContent: 'space-between' }}
      >
        <div>{label}</div>
        <div>
          <Button
            icon={Download}
            onPress={() =>
              window.open(
                `${_.get(pdfLinks, name, '')}?download=true`,
                '_blank'
              )
            }
            accessibilityLabel="Download"
            variant={{ text: true }}
          />
        </div>
      </li>
    );

  return (
    <>
      <>
        <Typography heading="h3" variant={{ size: 'h3' }} block>{attachments}</Typography>
        {(getLink('contractUnSigned', contractUnSigned) || contractUnSigned) &&
          !isCustomPricingCorporate && (
            <div className="card" style={{ marginTop: '1rem' }}>
              <div className="card-header">
                <Typography heading="h4" variant={{ size: 'h4' }} block>{labelContractPDF}</Typography>
              </div>
              <ul className="list-group list-group-flush">
                {(isOrderFulfillmentTeam || isAdmin) &&
                  getLink('contractUnSigned', contractUnSigned)}
                {getLink('contractSignedPdf', contractSignedPdf)}
              </ul>
            </div>
          )}
        <Attachements
          isUploadAvailable={isOrderFulfillmentTeam}
          orderData={orderData}
        />
      </>
    </>
  );
};

OrderAttachments.propTypes = {
  orderData: PropTypes.objectOf(PropTypes.any).isRequired
};

export default OrderAttachments;
